module.exports = __webpack_public_path__ + "static/HR Portal Stellvertretung festlegen-8b7106ff13ea2f5a72609ff70b99f5e8.jpg";